import { ReactNode } from "react"
import { Checkbox, ListItem, ListItemLabel } from "@mezo-org/mezo-clay"

type AutoMigrateListItemProps = {
  listItemLabel?: ReactNode
  withBorder?: boolean
  isDisabled?: boolean
  isChecked: boolean
  setIsChecked?: (isChecked: boolean) => void
}
export default function AutoMigrateListItem({
  listItemLabel = "Auto-bridge deposit to Mainnet",
  withBorder,
  isDisabled,
  isChecked,
  setIsChecked,
}: AutoMigrateListItemProps) {
  return (
    <ListItem
      state={isDisabled ? "disabled" : "enabled"}
      endEnhancer={() => (
        <Checkbox
          disabled={isDisabled}
          checked={isChecked}
          onChange={(event) => setIsChecked?.(event.target.checked)}
        />
      )}
      overrides={{
        Root: {
          style: ({ $theme }) => ({
            background: "transparent",
            margin: `${$theme.sizing.scale600} 0`,
          }),
        },
        Content: {
          style: () => ({
            ...(!withBorder && { border: "none" }),
          }),
        },
      }}
    >
      <ListItemLabel
        description="Auto-bridging for deposits will begin with the upcoming launch in May 2025"
        {...(!isDisabled && {
          overrides: {
            LabelContent: {
              style: ({ $theme }) => ({
                color: $theme.colors.contentPrimary,
              }),
            },
            LabelDescription: {
              style: ({ $theme }) => ({
                color: $theme.colors.contentSecondary,
              }),
            },
          },
        })}
      >
        {listItemLabel}
      </ListItemLabel>
    </ListItem>
  )
}
